import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { FormField, FormItem, FormLabel, FormDescription, FormMessage, FormControl } from '@/shared/components/ui/form';
import { BaseFieldProps } from './types';
import { IntegrationSelector } from '@/features/Integrations/components/IntegrationSelector';
import { AgentBaseService } from '@/features/Agents/services/agentBaseService';

interface IntegrationSelectorFieldProps extends BaseFieldProps {}

export const IntegrationSelectorField: React.FC<IntegrationSelectorFieldProps> = ({ 
  field, 
  name, 
  control 
}) => {
  const params = useParams();
  const agentId = params.id;

  // Buscar dados do agente para obter suas integrações
  const { data: _agentData } = useQuery({
    queryKey: ['agent', agentId], // Usar mesma chave que é invalidada em AgentSettings
    queryFn: () => agentId ? AgentBaseService.getById(agentId) : null,
    enabled: !!agentId
  });

  return (
    <FormField
      control={control}
      name={name}
      render={({ field: formField }) => (
        <FormItem>
          <FormLabel>{field.label}</FormLabel>
          <FormControl>
            <IntegrationSelector
              agentId={agentId!}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
              filter={(field as any).filter}
              value={formField.value}
              onChange={formField.onChange}
              placeholder={`Selecione ${field.label}`}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
              disabled={(field as any).disabled}
              className="w-full"
            />
          </FormControl>
          {field.description && <FormDescription>{field.description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default IntegrationSelectorField;
